const BaseValidator = {
  cannotEmpty(props) {
    return new Promise((resolve) => {
      let res;
      if (props.required && !props.value) {
        const t = props.t;
        let message = props.name + ' is required.';
        if (t) {
          message = `${t('validators.isRequired', { name: props.name })} `;
        }
        res = {
          success: false,
          props,
          message,
        };
      } else {
        res = {
          success: true,
          props,
          message: '',
        };
      }
      resolve(res);
    });
  },
};

export default BaseValidator;
